import { useContext, useRef } from 'react';
import { GroupActionContext } from '../components/GroupAction/provider';

function useGroupAction(component, initialVariant) {
  const { content, setContent, variant, setVariant, isOpen, show } = useContext(GroupActionContext);

  const ref = useRef();

  if (component) {
    ref.current = component;
    setContent(ref);
  }

  if (initialVariant) {
    setVariant(initialVariant);
  }

  return {
    content,
    isOpen,
    variant,
    show,
  };
}

export { useGroupAction };
